import React from 'react';
import TempleScreenShot from '../../AuxiliaryComponent/ScreenShot/TempleScreenShot';
import FullPageSpecialSimulator from '../FullPageSpecialSimulator';
import { Android } from '../../../../utils/DictionaryManagementUtils';
import PhoneFrame from '../../AuxiliaryComponent/Images/PhoneFrame';

//= ========================================================================

const SplashScreenSecurityFP = ({
  globJSON,
  simPlatform,
  imageSource,
  LabelInputText,
  TopTitle,
  withStatusBar,
  slideshowRefs,
}) => (
  <FullPageSpecialSimulator
    globJSON={globJSON}
    simPlatform={simPlatform}
    WithImageBackground={imageSource}
    TopTitle={TopTitle}
    LabelInputText={LabelInputText}
    numOfPointThatGetColor={4}
    withStatusBar={withStatusBar}
    slideshowRefs={slideshowRefs}
  >
    <TempleScreenShot
      globJSON={globJSON}
      simPlatform={simPlatform}
    />
    {simPlatform !== Android && withStatusBar && (<PhoneFrame />)}
  </FullPageSpecialSimulator>
);
export default SplashScreenSecurityFP;
